import { render, staticRenderFns } from "./instroductionWarranty.vue?vue&type=template&id=20218d54&"
import script from "./instroductionWarranty.vue?vue&type=script&lang=js&"
export * from "./instroductionWarranty.vue?vue&type=script&lang=js&"
import style0 from "./instroductionWarranty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports